export const STORAGE_KEYS = {
    SUPPLIER_NETWORK_ID: 'supplier_network_id',
    SUPPLIER_NETWORK_NAME: 'supplier_network_name',
    SUPPLIER_NETWORK_TOKEN: 'supplier_network_token',
} as const;

